export default __webpack_public_path__ + "static/media/building1.4f853a2e.png";